import { Component } from '@angular/core';
import { PaymentService } from '@core/payments/services/payment.service';
import { LoaderService } from '@shared/services/loader.service';
import { SignJWT } from 'jose';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-confirmation-dam',
    templateUrl: './confirmation-dam.component.html',
    styleUrls: ['./confirmation-dam.component.css'],
    standalone: false
})
export class ConfirmationDAMComponent {
  public titlepayment: string = '¡Felicidades!';
  public estatuspayment: string = 'APROBADO';
  public aprobedpayment: boolean = true;
  public currintpayment: string = '0';
  public numberauth: string = '0';
  public datepayment: string = '';
  public cardpaymnent: string = '';
  public bodymessage: string = '';
  public bodyemail: string = '';
  public subjectemail: string =
    'Afiliación exitosa a Débito Automático Mensual';
  constructor(
    private _paymentService: PaymentService,
    private _loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    if (this._paymentService.uploadcard && !this._paymentService.finishpin) {
      this.titlepayment = '¡Cambio de tarjeta exitoso!';
      this.bodymessage =
        'Se ha realizado el cambio de tarjeta afiliada al Débito Automático Mensual de tu factura';
      const bodyemail =
        'Hemos realizado el cambio de tarjeta ' +
        this.cardpaymnent +
        ' asociado al servicio ' +
        this._paymentService.numberphone +
        ' para tu   D&eacute;bito Autom&aacute;tico Mensual.';
      this.enviarEmail(
        'Afiliación exitosa a Débito Automático Mensual',
        bodyemail
      );
    } else if (
      this._paymentService.uploadcard &&
      this._paymentService.finishpin
    ) {
      this.titlepayment = '¡Error!';
      this.estatuspayment = 'RECHAZADA';
      this.aprobedpayment = false;
      this.bodymessage =
        'Ha ocurrido un error al intentar cambiar tu método de pago para el Débito Automático Mensual de la factura de tu servicio ' +
        this._paymentService.numberphone +
        '.';
      const bodyemail =
        'Ha ocurrido un error para el cambio de tu m&eacute;todo de pago para el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
        this._paymentService.numberphone +
        ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
      this.enviarEmail(
        'Cambio de tarjeta fallido Débito Automático Mensual',
        bodyemail
      );
    } else {
      var referencia = localStorage.getItem('phoneNumber');
      this.currintpayment =
        this._paymentService.requestpayment.result.totalAmount;
      this.numberauth = this._paymentService.requestpayment.result.cus;
      this.datepayment = this._paymentService.requestpayment.result.dateFormat
        .split('a las ')
        .join('');
      this.cardpaymnent =
        this._paymentService.requestpayment.result.paymentMethod.split(
          '************'
        )[1];

      if (this._paymentService.finishpin) {
        this.titlepayment = '¡Error!';
        this.estatuspayment = 'RECHAZADA';
        this.aprobedpayment = false;
        this.bodymessage =
          'Ha ocurrido un error al intentar afiliar el Débito Automático mensual de la factura de tu servicio ' +
          referencia +
          ' a tu tarjeta con terminación ' +
          this.cardpaymnent +
          '.';
        const bodyemail =
          'Ha ocurrido un error al activar el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
          referencia +
          ' a tu tarjeta con terminaci&oacute;n ' +
          this.cardpaymnent +
          ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
        this._paymentService
          .deleteDomin(
            this._paymentService.requestpayment.result
              .EnrollAutomaticPaymentResult.result.tokenDomi
          )
          .subscribe((resdelt) => {
            this.enviarEmail(
              'Afiliación fallida a Débito Automático Mensual',
              bodyemail
            );
          });
      } else {
        if (this._paymentService.requestpayment.result.status === 'DECLINED') {
          this.titlepayment = '¡Error!';
          this.estatuspayment = 'RECHAZADA';
          this.aprobedpayment = false;
          this.bodymessage =
            'Ha ocurrido un error al intentar afiliar el Débito Automático mensual de la factura de tu servicio ' +
            referencia +
            ' a tu tarjeta con terminación ' +
            this.cardpaymnent +
            '.';
          const bodyemail =
            'Ha ocurrido un error al activar el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
            referencia +
            ' a tu tarjeta con terminaci&oacute;n ' +
            this.cardpaymnent +
            ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
          this.enviarEmail(
            'Afiliación fallida a Débito Automático Mensual',
            bodyemail
          );
        } else {
          this._paymentService
            .updateDomin(
              this._paymentService.requestpayment.result
                .EnrollAutomaticPaymentResult.result.tokenDomi
            )
            .subscribe(
              (res) => {
                console.log(res);
                if (res.resultCode === 'ERROR') {
                  this.titlepayment = '¡Error!';
                  this.estatuspayment = 'RECHAZADA';
                  this.aprobedpayment = false;
                  this.bodymessage =
                    'Ha ocurrido un error al intentar afiliar el Débito Automático mensual de la factura de tu servicio ' +
                    referencia +
                    ' a tu tarjeta con terminación ' +
                    this.cardpaymnent +
                    '.';
                  const bodyemail =
                    'Ha ocurrido un error al activar el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
                    referencia +
                    ' a tu tarjeta con terminaci&oacute;n ' +
                    this.cardpaymnent +
                    ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
                  this._paymentService
                    .deleteDomin(
                      this._paymentService.requestpayment.result
                        .EnrollAutomaticPaymentResult.result.tokenDomi
                    )
                    .subscribe((resdelt) => {
                      this.enviarEmail(
                        'Afiliación fallida a Débito Automático Mensual',
                        bodyemail
                      );
                    });
                } else {
                  console.log("respuesta domi: "+ JSON.stringify(res));
                  if(res.resultMessage === '¡Felicidades!'){
                    this.bodymessage =
                      'Tu solicitud de afiliación al Débito Automático mensual ha sido recibida para el servicio ' +
                      referencia +
                      ' a tu tarjeta con terminación ' +
                      this.cardpaymnent +
                      '. Para finalizar el proceso, es necesario firmar el contrato correspondiente.';
                  }else{
                    this.bodymessage =
                      'Se ha activado exitosamente el Débito Automático mensual de la factura de tu servicio ' +
                      referencia +
                      ' a tu tarjeta con terminación ' +
                      this.cardpaymnent +
                      '.';
                    const bodyemail =
                      'Has activado el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
                      referencia +
                      ' a tu tarjeta con terminaci&oacute;n ' +
                      this.cardpaymnent +
                      ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
                    this.enviarEmail(
                      'Afiliación exitosa a Débito Automático Mensual',
                      bodyemail
                    );
                  }
                }
              },
              (error) => {
                this.titlepayment = '¡Error!';
                this.estatuspayment = 'RECHAZADA';
                this.aprobedpayment = false;
                this.bodymessage =
                  'Ha ocurrido un error al intentar afiliar el Débito Automático mensual de la factura de tu servicio ' +
                  referencia +
                  ' a tu tarjeta con terminación ' +
                  this.cardpaymnent +
                  '.';
                const bodyemail =
                  'Ha ocurrido un error al activar el D&eacute;bito Autom&aacute;tico mensual de la factura de tu servicio ' +
                  referencia +
                  ' a tu tarjeta con terminaci&oacute;n ' +
                  this.cardpaymnent +
                  ' que se realizar&aacute; 8 d&iacute;as antes del vencimiento de tu factura.';
                this.enviarEmail(
                  'Afiliación fallida a Débito Automático Mensual',
                  bodyemail
                );
              }
            );
        }
      }
    }
  }

 async enviarEmail(subjectemail: string, body: string) {
      const secretKey = new TextEncoder().encode(localStorage.getItem('clnum') as string);
      const payload = {
        channel: Number(localStorage.getItem('channel')),
        status: this.estatuspayment,
        message: body,
        factura: localStorage.getItem('numerofactura'),
        asunto: subjectemail,
        correo:
          this._paymentService.email ||
          this._paymentService.emailFromDom ||
          localStorage.getItem('email') ||
          '',
        phoneNumber: localStorage.getItem('phoneNumber'),
        numberCard: this.cardpaymnent,
        clnum : localStorage.getItem('clnum')
      }
      const jwt = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setExpirationTime('1h')
      .sign(secretKey);

    const hash1 = await this._paymentService.hashSHA256('c3n4ms3rv1c3');
    const hash2 = await this._paymentService.hashSHA256(
      'cmViUUFLQ0NuQkNUb1BLQXU3d3FNMUFhcENMMnVzWE46Rm5XcjFUendETDNwUmQwZQ==' +
        hash1
    );

    const auth =  this._paymentService.getAuthToken();

    this._paymentService
      .sendEmailConfirmationDAM(hash2, jwt, auth)
      .pipe(
        finalize(() => {
          this._loaderService.hideLoading();
        })
      )
      .subscribe({
        next: (res) => {
          console.log('Email sent successfully!', res);
        },
        error: (err) => {
          console.log('Error sending email confirmation:', err);
        },
      });
  }
}